//import $ from 'jquery';

const
  NAME               = 'scrollProgress',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],
  INIT_DELAY         = 500
;

var _bar$, _window$, _doc$;

class ScrollProgress {
  constructor(element$) {
    _bar$     = element$.children();
    _window$  = $(window);
    _doc$     = $(document);
    _window$.scroll(this.onScroll.bind(this));
    setTimeout(() => this.onScroll(), INIT_DELAY);
  }

  onScroll() {
    var progressWidth, scrollHeight, scrollTop;

    scrollHeight  = _doc$.height();
    scrollTop     = _window$.scrollTop();
    progressWidth = Math.round(scrollTop * 100 / (scrollHeight - window.innerHeight));

    _bar$.css('width', `${progressWidth}%`);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new ScrollProgress($(this));
    });
  }
}

$.fn[NAME]             = ScrollProgress._jQueryInterface;
$.fn[NAME].Constructor = ScrollProgress;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return ScrollProgress._jQueryInterface;
};

export default ScrollProgress;



// WEBPACK FOOTER //
// ./src/plugins/scroll-progress.js